var _ellipse, _ellipse2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadedFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 16,
    rx: 16,
    ry: 16,
    fill: "#EEF0F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_561_6277",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 16,
    rx: 16,
    ry: 16,
    fill: "#EEF0F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_561_6277)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.90165 26.242L23.4897 6.00699L37.1369 19.1832L19.1859 36.5139L8.90165 26.242Z",
    fill: "url(#paint0_linear_561_6277)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.90137,
    y: 5.6445,
    width: 15.0588,
    height: 21.4299,
    rx: 1.36842,
    fill: "#CCD0D5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.90137,
    y: 5.06534,
    width: 14.4796,
    height: 21.4299,
    rx: 1.36842,
    fill: "url(#paint1_linear_561_6277)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.7832,
    y: 17.228,
    width: 6.95023,
    height: 1.73756,
    rx: 0.86878,
    fill: "#D1D2D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.7832,
    y: 20.1242,
    width: 11.2941,
    height: 1.88235,
    rx: 0.941175,
    fill: "#D1D2D7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.2583,
    cy: 10.4228,
    rx: 3.47511,
    ry: 3.47511,
    fill: "#498BEE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.2582,
    cy: 10.4225,
    rx: 2.31674,
    ry: 2.31674,
    fill: "#2F68BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2229 8.75812C14.7036 8.75812 15.0917 9.14071 15.0917 9.61466C15.0917 10.0886 14.7036 10.4712 14.2229 10.4712C13.7422 10.4712 13.3541 10.0886 13.3541 9.61466C13.3541 9.14071 13.7422 8.75812 14.2229 8.75812ZM14.2229 12.8124C13.4989 12.8124 12.8589 12.447 12.4854 11.8931C12.4941 11.3249 13.6437 11.0137 14.2229 11.0137C14.7992 11.0137 15.9518 11.3249 15.9605 11.8931C15.5869 12.447 14.9469 12.8124 14.2229 12.8124Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_561_6277",
    x1: 13.3576,
    y1: 11.7278,
    x2: 28.2189,
    y2: 27.2149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_561_6277",
    x1: 16.1412,
    y1: 5.06534,
    x2: 16.1412,
    y2: 45.6083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedFile);
export default __webpack_public_path__ + "static/media/uploaded_file.7765fae7e7268b003bf020848f99b19c.svg";
export { ForwardRef as ReactComponent };